// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JPHQz","content":"styles_content__3SnMW"};